import { ScreenElementsStateProps } from '../states/ScreenElementsState'

import {
  DRAWER_DEFAULT_CONTENT_WIDTH,
  DRAWER_DESKTOP_LEFT_OFFSET,
  DRAWER_SIDEBAR_WIDTH
} from '@/presentation/modules/Base/components/Drawer/Drawer.constants'
import {
  METEOROLOGY_PLAYER_PANEL_GAP,
  METEOROLOGY_PLAYER_WIDTH
} from '@/presentation/modules/Base/components/MeteorologyControl/MeteorologyControl.constants'

export interface MeteorologyControlPosition {
  // Deslocamento do centro do controle em relação ao centro da tela.
  horizontalOffset: number
  // O player não coube na área livre: encosta no painel da esquerda e desce para passar por baixo
  // do painel de ferramenta.
  alignedToLeftPanel: boolean
}

const MAIN_DRAWER_RIGHT_EDGE = DRAWER_DESKTOP_LEFT_OFFSET + DRAWER_SIDEBAR_WIDTH + DRAWER_DEFAULT_CONTENT_WIDTH

export function getMeteorologyControlPosition(
  screenElementsState: ScreenElementsStateProps,
  viewportWidth: number
): MeteorologyControlPosition {
  const { boundsDefaultPadding } = screenElementsState
  const hasLeftPanel = screenElementsState.drawer || screenElementsState.mainDrawer
  const hasRightPanel =
    screenElementsState.toolPanel || screenElementsState.featureInfoPanel || screenElementsState.chat

  if (!hasLeftPanel && !hasRightPanel) {
    return { horizontalOffset: 0, alignedToLeftPanel: false }
  }

  // O menu principal expandido cobre a mesma faixa do Drawer na largura padrão. Se o Drawer estiver
  // expandido, ele vai mais longe e prevalece.
  const leftEdge = Math.max(boundsDefaultPadding.left, screenElementsState.mainDrawer ? MAIN_DRAWER_RIGHT_EDGE : 0)
  const centeredOffset = (leftEdge - boundsDefaultPadding.right) / 2
  const freeWidth = viewportWidth - boundsDefaultPadding.right - leftEdge

  if (!hasLeftPanel || freeWidth >= METEOROLOGY_PLAYER_WIDTH) {
    return { horizontalOffset: centeredOffset, alignedToLeftPanel: false }
  }

  const alignedLeft = leftEdge + METEOROLOGY_PLAYER_PANEL_GAP

  // Nem encostado ele cabe na tela (ex.: o Drawer ocupa a tela toda no celular).
  if (alignedLeft + METEOROLOGY_PLAYER_WIDTH > viewportWidth) {
    return { horizontalOffset: centeredOffset, alignedToLeftPanel: false }
  }

  return {
    horizontalOffset: alignedLeft + METEOROLOGY_PLAYER_WIDTH / 2 - viewportWidth / 2,
    alignedToLeftPanel: true
  }
}
